import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { TextField } from 'rmwc';

import Dialog from '../dialog/dialog';
import * as styles from '../styles';
import { close, setErrors } from '../dialog/actions';
import { login, request } from './actions';
import { host } from '../utilities/requests';
import _ from 'lodash';

const cellphoneValidator = /^[0۰][9۹][\d۰-۹]{9}$/;
const cellphonePartialValidator = cellphoneValidator.toPartialMatchRegex();
const passwordValidator = /^.{8,255}$/;
const passwordPartialValidator = passwordValidator.toPartialMatchRegex();
export default class LoginDialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    };  

    state = {
        username: '',
        password: '',
        confirmPassword: '',
        cellphone: '',
        activeCode: '',
        isRecovery: false,
        cellphoneValidator,
        passwordValidator,
        isconfirm: false,
        errormsg: '',
        successmsg: ''
    }
    set_recovery() { 
        this.setState({
            isRecovery: true,
            errormsg: '',
            successmsg: ''
        });

    }
    set_login() {

        this.setState({
            isRecovery: false,
            errormsg: '',
            successmsg: ''
        });

    }
    goto_reset_pass() {
        this.setState({
            isconfirm: false,
            errormsg: '',
            successmsg: ''
        })
    }
    async reset_pass() {
        // debugger;
        this.setState({
            errormsg: '',
            successmsg: ''
        })
        if (this.state.cellphone.length < 11) {
            this.setState({
                errormsg: 'شماره همراه خود را به صورت صحیح وارد کنید'
            })
        }
        else { 
            var response = await this.context.store.dispatch(request({
                path: `/reset_password/`,
                body: {
                    mobile: this.state.cellphone,
                },
            }));

            if (response.errorId === 0) {
                this.setState({
                    successmsg: response.message,
                    isconfirm: true
                }); 
            }
            else {
                this.setState({
                    errormsg: response.message
                })
            }

        }

    }
    async reset_pass_confirm() {
        // debugger;
        var flag = 0;

        this.setState({
            errormsg: '',
            successmsg: ''
        });

        const validPassword = (
            this.state.password !== '' ||
            !(
                this.props.errors.password ||
                !this.state.password.match(passwordValidator)
            )
        );
        const validCellphone = (
            this.state.cellphone !== '' ||
            !(
                this.props.errors.cellphone ||
                !this.state.cellphone.match(cellphoneValidator)
            )
        );

        if (this.state.activeCode.length === 0) {
            this.setState({
                errormsg: 'کد تائید را وارد کنید'
            });
            flag = 1;
        }


        if (!validPassword) {
            this.setState({
                errormsg: 'برای رمز عبور حداقل 8 حرف وارد کنید'
            });
            flag = 1;
        }

        if (!validCellphone) {
            this.setState({
                errormsg: 'شماره همراه نامعتبر است'
            });
            flag = 1;
        }
        if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                errormsg: 'رمز عبور و تکرار آن یکی نیست '
            });
            flag = 1;
        }

        if (flag === 0) {
            var response = await this.context.store.dispatch(request({
                path: `/reset_password_confirm/`,
                body: {
                    mobile: this.state.cellphone,
                    activeCode: this.state.activeCode,
                    pass: this.state.password
                },
            }));
            if (response.errorId === 0) {  
                await this.context.store.dispatch(login(
                    this.state.cellphone.english(),
                    this.state.password.english(),
                ));
                this.setState({
                    errormsg :'',
                    isconfirm : false,
                    isRecovery : false,
                    successmsg : ''
                });
                this.refs.form.reset();
                this.context.store.dispatch([close(this.props.elementId)]);
            }
            else {
                this.setState({
                    errormsg: response.message
                })
            }

        }

    }

    renderBody() {
        const message = decodeURIComponent(escape(atob(this.context.store.getState().getIn(
            ['routing', 'locationBeforeTransitions', 'query', 'login_message'],
            '',
        ))));


        {

            if (this.state.isRecovery) {
                if (this.state.isconfirm) {
                    return <div style={styles.loginDialog}>
                        {message
                            ? <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em' }}>
                                {message}
                            </div>
                            : null
                        }
                        {
                            this.state.errormsg.length > 0 ?
                                <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em', color: '#f1824e' }}>
                                    {this.state.errormsg}
                                </div> : null
                        }

                        {
                            this.state.successmsg.length > 0 ?
                                <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em', color: 'green' }}>
                                    {this.state.successmsg}
                                </div> : null
                        }
                        <div
                            onKeyPress = {()=>this.reset_pass_confirm()}
                            style={{
                                marginBottom: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <div>
                                شماره همراه : {this.state.cellphone}
                            </div>
                            <br />
                            <div >
                                <TextField
                                    ref='code'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    type='text'
                                    label='کد بازیابی'
                                    autoComplete="ac-code"
                                    value={this.setState.activeCode}
                                    onChange={({ target: { value } }) => { 
                                        this.setState({ activeCode: value.english() });
                                    }}
                                />
                            </div>

                            <div >
                                <TextField
                                    ref='new-password'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    pattern={this.state.passwordValidator.source}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    type='password'
                                    autoComplete="new-password"
                                    label={window.gettext('password')}
                                    value={this.state.password}
                                    onChange={({ target: { value } }) => {
                                        value = value.english();
                                        if (value.length > 0 && !value.match(passwordPartialValidator))
                                            return;
                                        this.setState({ password: value });
                                    }}
                                    onFocus={() => this.setState({ passwordValidator: passwordPartialValidator })}
                                    onBlur={() => this.setState({ passwordValidator })}
                                />
                                <div style={styles.error}>
                                    {this.props.errors.password
                                        ? _.map(
                                            this.props.errors.password,
                                            (error, index) => <li style={{ display: 'block' }} key={index}>
                                                * {error}
                                            </li>,
                                        )
                                        : null
                                    }
                                </div>
                            </div>
                            <div >
                                <TextField
                                    ref='confirm_password'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    pattern={'^$|' + this.state.password}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    type='password'
                                    autoComplete="re-new-password"
                                    label={window.gettext('confirm password')}
                                    value={this.state.confirmPassword}
                                    onChange={({ target: { value } }) => this.setState({ confirmPassword: value.english() })}
                                />
                                <div style={styles.error}>
                                    {this.props.errors.confirm_password
                                        ? _.map(
                                            this.props.errors.confirm_password,
                                            (error, index) => <li style={{ display: 'block' }} key={index}>
                                                * {error}
                                            </li>,
                                        )
                                        : null
                                    }
                                </div>
                            </div>

                            <div style={styles.dialogButtonContainer}>
                                <button
                                    key='register'
                                    type='button'
                                    style={styles.dialogButton_large}
                                    onClick={()=>this.reset_pass_confirm()}>
                                    تائید اطلاعات
                                </button>
                            </div>

                            <div>
                                <a
                                    key='reset_pass'
                                    style={styles.reset_pass_btn}
                                    onClick={()=>this.goto_reset_pass()}>
                                    تغییر شماره موبایل
                                </a>
                            </div>
                        </div>
                    </div>

                }
                else {
                    return <div style={styles.loginDialog}>
                        {message
                            ? <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em' }}>
                                {message}
                            </div>
                            : null
                        }
                        {
                            this.state.errormsg.length > 0 ?
                                <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em', color: '#f1824e' }}>
                                    {this.state.errormsg}
                                </div> : null
                        }
                        <div
                            style={{
                                marginBottom: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            onKeyPress = {()=>this.reset_pass()}>
                            <div>
                                <TextField
                                    ref='cellphone'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    pattern={this.state.cellphoneValidator.source}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    label={window.gettext('cellphone')}
                                    value={this.state.cellphone.persian()}
                                    onChange={({ target: { value } }) => {
                                        value = value.english();
                                        if (value.length > 0 && !value.match(cellphonePartialValidator))
                                            return;
                                        this.setState({ cellphone: value });
                                    }}
                                    onFocus={() => this.setState({ cellphoneValidator: cellphonePartialValidator })}
                                    onBlur={() => this.setState({ cellphoneValidator })}
                                />
                                <div style={styles.error}>
                                    {this.props.errors.cell_phone
                                        ? _.map(
                                            this.props.errors.cell_phone,
                                            (error, index) =>
                                                <li style={{ display: 'block' }} key={index}>
                                                    * {error}
                                                </li>,
                                        ) : null
                                    }
                                </div>
                            </div>

                            <div style={styles.dialogButtonContainer}>
                                <button
                                    key='register'
                                    type='button'
                                    style={styles.dialogButton_large}
                                    onClick={()=>this.reset_pass()}>
                                    دریافت کد بازیابی
                                </button>
                            </div>

                            <div>
                                <a
                                    key='reset_pass'
                                    style={styles.reset_pass_btn}
                                    onClick={()=>this.set_login()}>
                                    ورود به حساب کاربری
                                </a>
                            </div>
                        </div>
                    </div>

                }
            }
            else {
                return <div style={styles.loginDialog}>
                    {message
                        ? <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em' }}>
                            {message}
                        </div>
                        : null
                    }
                    <form
                        ref='form'
                        style={{
                            marginBottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        onSubmit={async event => {
                            event.preventDefault();
                            try {
                                await this.context.store.dispatch(login(
                                    this.state.username.english(),
                                    this.state.password.english(),
                                ));
                                this.refs.form.reset();
                                this.context.store.dispatch([close(this.props.elementId)]);
                            }
                            catch (exception) {
                                console.error(exception);
                            }
                        }}>
                        <TextField
                            style={{ direction: 'ltr' }}
                            outlined
                            autoCorrect='off'
                            autoCapitalize='none'
                            label={<div style={{ lineHeight: '1.2em' }}>{window.gettext('username') + ' / ' + window.gettext('email')}</div>}
                            value={this.state.username}
                            onChange={({ target: { value } }) => this.setState({ username: value })}
                        />
                        <TextField
                            style={{ direction: 'ltr' }}
                            outlined
                            type='password'
                            label={<div style={{ lineHeight: '1.2em' }}>{window.gettext('password')}</div>}
                            value={this.state.password}
                            onChange={({ target: { value } }) => this.setState({ password: value })}
                        />
                        {this.props.loginError
                            ? <p style={styles.error}>
                                {this.props.loginError.errorDescription
                                    ? window.gettext(this.props.loginError.errorDescription)
                                    : window.gettext('Network error')
                                }
                            </p>
                            : null
                        }
                        <div style={styles.dialogButtonContainer}>
                            {this.props.pending > 0
                                ? <i className='fa-spin fa-spinner fa-2x'></i>
                                : <button
                                    key='submit'
                                    type='submit'
                                    style={styles.defaultDialogButton}>
                                    {window.gettext('login')}
                                </button>
                            }
                        </div>
                        <div style={styles.dialogButtonContainer}>
                            <button
                                key='register'
                                type='button'
                                style={styles.dialogButton}
                                onClick={() => {
                                    this.context.store.dispatch(push({
                                        ...this.context.store.getState().get('routing').get('locationBeforeTransitions').toJS(),
                                        query: { dialog: 'registration' },
                                    }));
                                }}>
                                {window.gettext('register')}
                            </button>
                        </div>

                        <div>
                            <a
                                key='reset_pass'
                                style={styles.reset_pass_btn}
                                onClick={()=>this.set_recovery()}>
                                بازیابی رمز عبور
                            </a>
                        </div>
                    </form>
                </div>

            }
        }


    }


    render() {
        return <Dialog {...this.props}>
            {this.renderBody.bind(this)()}
            {
                this.state.isRecovery ?
                    <span>
                        <br />
                        <i className='fa-lock fa-3x'></i>
                        <br />
                        بازیابی رمز عبور
                    </span>
                    :
                    <span>
                        <i className='fa-sign-in fa-3x'></i>
                        <br />
                        {window.gettext('log in to account')}
                    </span>
            }
        </Dialog>;
    }
};
